import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

// DateFns Format: https://date-fns.org/docs/format

@Pipe({
  name: 'displayDbDate',
})
export class DisplayDbDatePipe implements PipeTransform {
  // date should come in db-day-date format (yyyy-MM-dd)
  transform(date: string, dateFnsFormat: string) {
    return format(new Date(date), dateFnsFormat, { locale: de });
  }
}
